import { ITransaction } from './ITransaction';
import { Observable } from 'rxjs/Observable';
import { Merchant } from './../shared/merchant.model';
import { MonitorService } from './../shared/monitor.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy, AfterViewInit, Output, EventEmitter } from '@angular/core';
import * as $ from 'jquery';
import { Subject, timer } from 'rxjs';
import { takeUntil, switchMap, tap, map } from 'rxjs/operators';
import { NgxSpinnerService } from 'ngx-spinner';
// import { Router, ActivatedRoute } from '@angular/router';
import { ReportService } from '../shared/report.service';
import { NaturalezaContable } from '../bines/naturaleza-contable';
import { NaturalezasContableService } from '../bines/naturaleza-contable.service';
import { MonitorFilter } from '../shared/monitor.filter.model';

@Component({
  selector: 'pm-monitor',
  templateUrl: './monitor.component.html',
  styleUrls: ['./monitor.component.sass'],
  encapsulation: ViewEncapsulation.None
})
export class MonitorComponent implements OnInit, OnDestroy, AfterViewInit {
  public pageTitle = 'Monitor';
  rows = 0;

  public showFilter = false;

  // @Output() disengageEventEmitter: EventEmitter<string> = new EventEmitter<string>();

  // merchants = [];

  // merchantSelected: '0';
  // statusSelected = '0';
  // accountingNature: '0';
  monitorFilter: MonitorFilter = new MonitorFilter();

  lastTransactions = [];
  columnDefs = [
    { headerName: 'Referencia', field: 'retrievalId', width: 110 },
    { headerName: 'Cuenta', field: 'accountMasked', width: 140 },
    { headerName: 'Emisor', field: 'binCardIssuer' },
    { headerName: 'Monto', field: 'amount' },
    { headerName: 'Tipo', field: 'operationType' },
    { headerName: 'Estátus', field: 'status' },
    { headerName: 'RC', field: 'responseCode', width: 60 },
    { headerName: 'Respuesta', field: 'responseMessage', width: 110 },
    { headerName: 'Aut RM', field: 'authorizerRM' },
    { headerName: 'Aut RC', field: 'authorizerRC', width: 90 },
    { headerName: 'Folio', field: 'approvalCode', width: 80 },
    { headerName: 'Sucursal', field: 'merchantName', width: 150 },
    { headerName: 'PDV', field: 'posIdentifier', width: 80 },
    { headerName: 'Servicio', field: 'serviceName' },
    { headerName: 'Fecha', field: 'dateTime', width: 140 }
  ];

  defaultColDef = {
    width: 100 /*
    sortable: true,*/,
    resizable: true
  };

  dataSource = [];

  dataGridOptions = {
    pagination: false,
    paginationPageSize: 200,
    overlayLoadingTemplate:
      '<span class="titulos-1">No hay resultados que mostrar, favor de iniciar una búsqueda</span>',
    overlayNoRowsTemplate: '<span class="titulos-1">No hay resultados que mostrar, favor de iniciar una búsqueda</span>'
  };

  merchantList: Observable<Merchant[]> = this.service.getMerchants();
  accountingNatureList: Observable<NaturalezaContable[]> = this.accountingNatureService.allRecords();
  operationStatusList = this.reportService.getOperationStatus();

  private killTrigger: Subject<void> = new Subject();

  private fetchData$: Observable<ITransaction[]> = this.service.getLastTransactions(0, '0', '0');
  private refreshInterval$: Observable<ITransaction[]> = timer(0, 6000).pipe(
    takeUntil(this.killTrigger),
    switchMap(() => this.fetchData$)
  );

  public dataSource$: Observable<ITransaction[]> = this.refreshInterval$;
  // this.refreshInterval$.subscribe(val => {
  //       this.rows = val.length;
  //       console.log('---> ', this.rows);
  //     });

  constructor(
    public service: MonitorService,
    private spinnerService: NgxSpinnerService,
    public reportService: ReportService,
    private accountingNatureService: NaturalezasContableService
  ) {}

  ngAfterViewInit() {
    $('a[rel=dashboard]').addClass('selected');
    $('body').removeClass('backgroundLogin');
    $('a[rel=monitor]').addClass('selected');
  }

  ngOnInit() {
    // console.log('ngOnInit: Incoming...');
    // this.monitorFilter = new MonitorFilter();
    this.monitorFilter.merchantId = 0;
    this.monitorFilter.status = '';
    this.monitorFilter.accountingNature = '';
    console.log('ngOnInit: ', JSON.stringify(this.monitorFilter));

    // this.merchantSelected = 'Todas';
    // this.accountingNature = '';
    // this.activatedRoute.params.subscribe(params => {
    //   console.log('MonitorComponent: ngOnInit: dsc: ', params.dsc);
    // });
  }

  filterData() {
    this.showFilter = true;
  }

  onLastTxnMonitor(pMonitorFilter: MonitorFilter) {
    console.log(
      'MonitorComponent: onLastTxnMonitor: merchantId: ',
      pMonitorFilter.merchantId,
      ', status: ',
      pMonitorFilter.status,
      ', accountingNature: ',
      pMonitorFilter.accountingNature
    );
    if (pMonitorFilter.merchantId != null) {
      // console.log('MonitorComponent: onLastTxnMonitor: merchantSelected: ', this.merchantSelected);
      this.killTrigger.next();
      // this.fetchData$ = this.service.getLastTransactions(
      //   this.merchantSelected.id,
      //   this.statusSelected,
      //   this.accountingNature
      // );
      this.fetchData$ = this.service.getLastTransactions(
        pMonitorFilter.merchantId,
        pMonitorFilter.status,
        pMonitorFilter.accountingNature
      );
      console.log('MonitorComponent: onLastTxnMonitor: this.fetchData$: ', JSON.stringify(this.fetchData$));
      this.killTrigger = new Subject();
      this.refreshInterval$ = timer(0, 5000).pipe(
        takeUntil(this.killTrigger),
        switchMap(() => this.fetchData$)
      );

      this.dataSource$ = this.refreshInterval$;
      this.refreshInterval$.subscribe(val => {
        this.rows = val.length;
        console.log('---> ', this.rows);
      });
    }
  }

  // // @HostListener('click')
  // disengage() {
  //   console.log('eventEmitter...');
  //   this.disengageEventEmitter.emit('true');
  //   // this.router.navigate(['/monitor']);
  // }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  ngOnDestroy() {
    $('a[rel=monitor]').removeClass('selected');
    this.killTrigger.next();
  }
}
